


export const BASE_URL_API_TRANXT_UAT_API_GOSEO = `https://api.goseo.in`;
export const BASE_URL_API_TRANXT_UAT_API = `https://payroll.billpunch.com`;


export const BASE_URL_API_TRANX_BLOG = `https://blogapi.packky.com/api/Bumppy`;

